export const TEMPLATE_DETAILS = "TEMPLATE_DETAILS"
export const TEMPLATE_DETAILS_SUCCESS = "TEMPLATE_DETAILS_SUCCESS"
export const TEMPLATE_DETAILS_FAILED = "TEMPLATE_DETAILS_FAILED"

export const ADD_TEMPLATE = "ADD_TEMPLATE"
export const ADD_TEMPLATE_SUCCESS = "ADD_TEMPLATE_SUCCESS"
export const ADD_TEMPLATE_FAILED = "ADD_TEMPLATE_FAILED"

//get template
export const GET_TEMPLATE_DATA = "GET_TEMPLATE_DATA"
export const GET_TEMPLATE_DATA_SUCCESS = "GET_TEMPLATE_DATA_SUCCESS"
export const GET_TEMPLATE_DATA_FAIL = "GET_TEMPLATE_DATA_FAIL" 

export const EDIT_TEMPLATE = "EDIT_TEMPLATE"
export const EDIT_TEMPLATE_SUCCESS = "EDIT_TEMPLATE_SUCCESS"
export const EDIT_TEMPLATE_FAILED = "EDIT_TEMPLATE_FAILED"

export const DELETE_TEMPLATE = "DELETE_TEMPLATE"
export const DELETE_TEMPLATE_SUCCESS = "DELETE_TEMPLATE_SUCCESS"
export const DELETE_TEMPLATE_FAILED = "DELETE_TEMPLATE_FAILED"

export const GET_TEMPLATE = "GET_TEMPLATE"
export const GET_TEMPLATE_SUCCESS = "GET_TEMPLATE_SUCCESS"
export const GET_TEMPLATE_FAILED = "GET_TEMPLATE_FAILED"

export const TEMPLATE_PREVIEW = "TEMPLATE_PREVIEW"
export const TEMPLATE_PREVIEW_SUCCESS = "TEMPLATE_PREVIEW_SUCCESS"
export const TEMPLATE_PREVIEW_FAILED = "TEMPLATE_PREVIEW_FAILED"

